import MarkSerializer from './MarkSerializer';
import {
  type DeserializeArguments,
  type SerializeArguments,
  type MarkAttributes,
} from './Serializer';
import { Text } from 'slate';
import React from 'react';

class SerializerStyle extends MarkSerializer {
  static serialize({ node, children }: SerializeArguments): React.ReactNode {
    if (!Text.isText(node)) return;

    const { text, ...marks } = node;
    const { styles, otherProps } = this.marksToStyles(marks);

    if (Object.keys(styles).length > 0 || Object.keys(otherProps).length > 0) {
      return (
        <span style={styles} {...otherProps}>
          {children}
        </span>
      );
    }
  }

  static deserialize({
    el,
    markAttributes,
    next,
    context,
    options,
  }: DeserializeArguments) {
    // Don't recurse into elements we've already processed.
    if (context.styleElements?.has(el)) return;

    const newMarks: MarkAttributes = this.stylesToMarks(
      el as HTMLElement,
      options
    );

    // We didn't find any marks.
    if (Object.keys(newMarks).length === 0) return;

    // Process the element again with marks. We need to avoid recursion.
    const childAttributes = { ...markAttributes, ...newMarks };
    context.styleElements ||= new Set();
    context.styleElements.add(el);
    const result = next([el] as any as NodeList, childAttributes);
    context.styleElements.delete(el);
    return result;
  }
}

export default SerializerStyle;
